import { render, staticRenderFns } from "./ObjectTree.vue?vue&type=template&id=63cc395b&scoped=true"
import script from "./ObjectTree.vue?vue&type=script&lang=js"
export * from "./ObjectTree.vue?vue&type=script&lang=js"
import style0 from "./ObjectTree.vue?vue&type=style&index=0&id=63cc395b&prod&lang=css"
import style1 from "./ObjectTree.vue?vue&type=style&index=1&id=63cc395b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc395b",
  null
  
)

export default component.exports